(function () {
  'use strict';

  angular.module('app').component('resourcesPage', resourceListCrtl());

  function resourceListCrtl() {
    return {
      bindings: {},
      controller: ResourceListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/resources/resources-page.component.html',
    };
  }

  ResourceListCtrl.$inject = ['UtilService', 'AbilityService', 'ResourceService'];

  function ResourceListCtrl(UtilService, AbilityService, ResourceService) {
    const vm = this;

    // public properties
    // ----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_resource_accountadmin'),
    };

    // public methods
    // -----------------------
    vm.openAddResources = function () {
      ResourceService.openAddResources(getResources);
    };

    // private methods
    // -----------------------

    // Initializers
    getResources();

    function getResources() {
      vm.filterCriteria = ResourceService.getFilterCriteria();

      vm.loadingItems = true;
      ResourceService.getResources(vm.filterCriteria).then(function (data) {
        vm.resources = data.items;
        vm.meta = data.meta;

        vm.resources.sort((a, b) => (a.resource_contact.name > b.resource_contact.name ? 1 : -1));

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }
  }
})();

/*if (selectedItem){
                    vm.UtilService.itemListChanged(selectedItem.id);
                }*/

/*vm.createResource = function() {
            ResourceService.openResourceDetailModal({}, 'create', getResources);
        };

        vm.onShowResource = function(resource, mode) {
            ResourceService.openResourceDetailModal(resource, mode);
        };*/
